import { UpdateDonneesJudiciairesRequestDto } from 'lib_api/lib/api/gen';

import { UpdateDonneesJudiciairesFormValues } from './types';

export const buildUpdateDonneesJudiciairesDto = (
  values: UpdateDonneesJudiciairesFormValues,
): UpdateDonneesJudiciairesRequestDto => {
  return {
    newIdCorrelationJuridiction:
      values.newJuridiction?.option?.idCorrelation || null,
    newNumeroParquet: values.newNumeroParquet ?? null,
    newNumeroPv: values.newNumeroPv ?? null,
    newNumeroIDJ: values.newNumeroIDJ ?? null,
    newValeurJuridique: values.newValeurJuridique ?? null,
  };
};
